export default {
  THEME_STATUS_NEW: 'theme_new',
  THEME_STATUS_STARTED: 'theme_viewed',
  THEME_STATUS_COMPLETED: 'theme_completed',
  THEME_STATUS_UPDATED: 'theme_updated',
  THEME_STATUS_CHAPTER_VIEWED: 'theme_chapter_viewed',
  THEME_STATUS_INTRO_CHAPTER_VIEWED: 'collection_theme_intro_chapter_viewed'
};
